/**
 * @module utils/whenFontsReady
 *
 * A single, memoised promise that resolves once web fonts have loaded (or
 * immediately if the Font Loading API is unavailable). Anything that measures
 * text — SplitText line-splitting, FitHeading's font-size search, ScrollTrigger
 * positions — must wait on this so it measures the real typeface, not the
 * fallback, and only does the work once.
 */

let readyPromise = null;

export default function whenFontsReady() {
	if (!readyPromise) {
		readyPromise = (document.fonts?.ready ?? Promise.resolve()).then(() => {});
	}
	return readyPromise;
}
